export const ESP_ENDPOINTS = {
    GET_ACCESS_TOKEN: "/2.0/auth/getAccessToken?referencetoken=",
    GET_REFRESH_TOKEN: "/2.0/auth/RefreshToken",
    VALIDATE_LOGIN: "/2.0/User/ValidateToken",
    GET_USER_DETAILS: "/2.0/User/GetUserDetailsbyToken",
    GET_USER_MENU: "/2.0/User/GetUserMenuDetailByUserId",
    CHECK_ACCESS_FOR_CUSTOMER: "/2.0/Determine/Project/CheckCaseAccessForCustomer?CaseId=",
    GET_ALL_CUSTOMERS: "/2.0/Determine/RBAC/RBACCustomerByCompany?companay=",
    GET_ALL_PROJECTS: "/2.0/Determine/Project/GetProjectList1",
    CREATE_NEW_CASE: "/2.0/Determine/Project/createnewcase",
    UPDATE_CASE_DETAILS: "/2.0/Determine/Project/UpdateCaseDetails?projectID=",
    GET_OTHER_PROJECTS: "/2.0/Determine/Project/GetProjectList2",
    GET_PIN_PROJECTS: "/2.0/Determine/Project/GetPinProjectList",
    UPDATE_PIN_STATUS: "/2.0/Determine/Project/UpdatePinStatus",
    GET_RECENT_PROJECTS: "/2.0/Determine/Project/GetRecentProjectList",
    COPY_PROJECTS: "/2.0/Determine/Project/_CopyProject1",
    UPDATE_PROJECT_STATUS: "/2.0/Determine/Project/UpdateProjectStatus?id=",
    SHARE_WITH_CUSTOMER: "/2.0/Determine/Project/ShareWithCustomer",
    GET_SHARED_CASES: "/2.0/Determine/Project/GetSharedCases",
    REMOVE_PROJECTS: "/2.0/Determine/Project/Delete",
    GET_GLOBAL_TEMPLATES: "/2.0/Determine/Project/GobalTemplates",
    DOWNLOAD_MAIN_REPORT: "/2.0/Determine/Calculation/DownloadMainReport/",
    GET_PROJECT_STATUS_COUNT: "/2.0/Determine/Project/GetProjectStatusCount",
    GET_RECENT_CUSTOMER_FEEDBACK: "/2.0/Determine/Project/GetCustomerFeedbackList",
    GET_CASING_OD: "/2.0/Determine/Calculation/GetCasingOD",
    GET_CASING_WEIGHT_LIST: "/2.0/Determine/Calculation/GetCasingWeightList",
    GET_CASING_ID: "/2.0/Determine/Calculation/GetCasingID",
    GET_FLOP_VALUE: "/2.0/Determine/ESP/GetFLOPValue",
    GET_OIL_API_CHANGE: '/2.0/Determine/Calculation/GetOilAPIChange',
    GET_RESV_PRESR_CHANGE: '/2.0/Determine/Calculation/GetResvPresrChange',
    GET_STAT_FLD_CHANGE: '/2.0/Determine/Calculation/GetStatFldChange',
    GET_INFLOW_CALCULATIONS: '/2.0/Determine/Calculation/InflowCalculations',
    GET_SR_CABLES: "/2.0/Determine/SchematicCorrelation/SRCables",
    GET_PROD_RATE_CHANGE: '/2.0/Determine/Calculation/GetProdRateChange',
    GET_WATER_CUT_CHANGE: '/2.0/Determine/Calculation/GetWaterCutChangeOilCt',
    GET_WATER_CUT_COMB_SP_GR: '/2.0/Determine/Calculation/GetWaterCtChangeCombSpGr',
    GET_BUBBLE_POINT: '/2.0/Determine/Calculation/GetBubblPnt',
    GET_GAS_CALC_DATA: '/2.0/Determine/Calculation/GetGasCalcData',
    GET_LINER_OD_LIST: '/2.0/Determine/Calculation/GetLinerODList',
    GET_LINER_ID: '/2.0/Determine/Calculation/GetLinerID',
    GET_CASING_DRIFT_ID: '/2.0/Determine/Calculation/GetCasingDriftID',
    GET_LINER_WEIGHT_LIST: '/2.0/Determine/Calculation/GetLinerWeightList',
    GET_TUBING_WEIGHT_LIST: '/2.0/Determine/Calculation/GetTubingWeightList',
    GET_TUBING_ID: '/2.0/Determine/Calculation/GetTubingID',
    GET_SP_GR_OIL_CHANGE: '/2.0/Determine/Calculation/GetSpGrOilChange',
    GET_FLUID_VISCOSITY_CHANGE: '/2.0/Determine/Calculation/GetFluidViscosityChange',
    GET_STATES_BY_COUNTRY: "/2.0/Determine/Project/GetStatesByCountry",
    GET_COUNTY_LIST: "/2.0/Determine/Project/GetCountyList",
    GET_COUNTRY_BY_STATE: "/2.0/Determine/Project/GetCountryByState",
    GET_WELL_DETAILS: "/2.0/Determine/RBAC/RBACWell",
    GET_WELLS_BY_ID: "/2.0/Determine/Connexia/CNXWellsById",
    GET_CUSTOMER_BY_ID: "/2.0/Determine/RBAC/RBACOperatorsById",
    GET_ACCOUNT_MANAGERS: "/2.0/Determine/User/GetAccoutManagerRoleUsers",
    GET_PROJECT_AFFILIATIONS: "/2.0/Determine/Project/Getprojectaffiliations",
    GET_BATCH_CASE_CALCULATIONS: "/2.0/Determine/ESP/BatchCaseCalculations",
    GET_CALCULATIONS: "/2.0/Determine/ESP/Calculations",
    ON_CALCULATE: "/2.0/Determine/ESP/ToTest",
    SAVE_PROJECT: "/2.0/Determine/ESP/Calculations1",
    SAVE_SCHEMATICS: "/2.0/Determine/SchematicCorrelation/SaveSchematics",
    GET_SCHEMATIC_DATA: "/2.0/Determine/SchematicCorrelation/Schematics",
    GET_SET_DEPTH: "/2.0/Determine/SchematicCorrelation/Calculation",
    GET_SURFACE_VOLTAGE: "/2.0/Determine/SchematicCorrelation/SurfaceVoltage",
    GET_MOTOR_LOAD_DIFFERENT_FREQUENCY: "/2.0/Determine/SchematicCorrelation/MotorLoadDifferentFrequency",
    CHECK_PROJECT_NAME_EXISTS: "/2.0/Determine/Project/ProjNameExists",
    SAVE_MAIN_REPORT_DATA: "/2.0/Determine/Calculation/SaveMainReportData",
    GET_CASE_COMPARISION: "/2.0/Determine/Project/GetCaseComparision",
    GET_IPR_DATA: "/2.0/Determine/ESP/WellInflowList",
    GET_TDH_DATA: "/2.0/Determine/Calculation/GetTDHOPs",
    GET_DEPLETION_GRAPH_DATA: "/2.0/Determine/ESP/GetDepletionGraphData",
    GET_IPR_GRAPH_DATA: "/2.0/Determine/ESP/GetIPRGraphData",
    GET_DEPLETION_PERCENTAGE: "/2.0/Determine/ESP/GetDepletionPercentage",
    GET_FUTURE_BHP: "/2.0/Determine/ESP/GetFutureBHP",
    GET_NEW_TDH: "/2.0/Determine/Calculation/GetNewTDH",
    GET_BASIC_CAL_SERVICE: "/2.0/Determine/Calculation/GetTailPipeTZ",
    GET_TAIL_PIPE_TZ: "/2.0/Determine/Calculation/getTailPipeTZ",
    GET_CABLE_LENGTH: "/2.0/Determine/ESP/GetCableLength",
    GET_CABLE_VOLT_DATA: "/2.0/Determine/Calculation/GetCableVoltData",
    GET_WELL_CABLE_LIST: "/2.0/Determine/ESP/CableSelection",
    GET_MOTOR_LEAD_LIST: "/2.0/Determine/ESP/GetCableMotrLead",
    GET_SR_MLE: "/2.0/Determine/SchematicCorrelation/SRMLE",
    GET_CLEARANCE_DATA: "/2.0/Determine/Calculation/GetClearnceOP",
    GET_CLEARANCE_CHART: "/2.0/Determine/ESP/GetClearanceChart",
    GET_SEPS_LIST: "/2.0/Determine/ESP/GetSepsList",
    GET_POWER_RATING: "/2.0/Determine/Calculation/GetGasSepHP",
    GET_ANCHOR_TUBING_OD: "/2.0/Determine/Calculation/GetAnchorTubngOD1",
    GET_ANCHOR_ID: "/2.0/Determine/Calculation/GetAnchorID",
    GET_TFV_WARNING: "/2.0/Determine/ESP/SepTFVWarng",
    GET_GAS_DESIGN_CHANGE: "/2.0/Determine/Calculation/GetGasDesignChange1",
    GET_CHARGE_PUMP_LIST: "/2.0/Determine/Calculation/GetChPmpList",
    GET_SR_GAS_SEPARATORS: "/2.0/Determine/SchematicCorrelation/SRGasSeparators",
    GET_SR_GAS_HANDLERS: "/2.0/Determine/SchematicCorrelation/SRGasHandlers",
    GET_GAS_SEP_EFFICIENCY: "/2.0/Determine/Calculation/GetGasSepEff",
    GET_GAS_EFF_CHANGE: "/2.0/Determine/Calculation/GetGasEfficncyChange",
    GET_GKX_LIST: "/2.0/Determine/Calculation/GetGKXList",
    GET_SPECIAL_PUMP_CALCULATIONS: "/2.0/Determine/ESP/GetSpecialPumpsCalculations",
    GET_GKX_GRAPH_DATA: "/2.0/Determine/Calculation/GetGKXPumpCapacityCurvesGraphData",
    GET_GAS_CHG_PUMP_CHANGE: "/2.0/Determine/Calculation/GetGasChPmp1Change",
    GET_SR_PUMPS: "/2.0/Determine/SchematicCorrelation/SRPumps",
    GET_CP_GRAPH_DATA: "/2.0/Determine/Calculation/GetPumpCapacityCurvesGraphData",
    GET_GKX_CALCULATIONS: "/2.0/Determine/Calculation/GetChargePmpChange",
    GET_GKX_PUMP_CHANGE: "/2.0/Determine/Calculation/GetGasCalculationsOnGKXPumpChange",
    GET_MOTOR_LIST: "/2.0/Determine/ESP/MotorSelectn",
    GET_MOTOR_ITERATION: "/2.0/Determine/ESP/MotorIteration",
    GET_MOTOR_CALCULATION: "/2.0/Determine/ESP/MotorCirculatn?",
    GET_SHROUD_OD: "/2.0/Determine/Calculation/GetShroudOD?",
    GET_SHROUD_CALCULATION: "/2.0/Determine/ESP/GetShroudCalc",
    GET_MOTOR_PERFORMANCE_DATA: "/2.0/Determine/ESP/MotorPerformancePlotData?",
    GET_SR_MOTORS: "/2.0/Determine/SchematicCorrelation/SRMotors?",
    GET_MOTOR_OIL_TEMP_CHK: "/2.0/Determine/ESP/MtrOilTempChk",
    GET_PROTECTOR_SERIES: "/2.0/Determine/ESP/ProtectrDropDownsData",
    GET_PROTECTOR_LIST: "/2.0/Determine/ESP/ProtectrSelectn",
    GET_PROTECTOR_OIL_CONTRACTION: "/2.0/Determine/ESP/ProtcOilExpnsn",
    GET_PROTECTOR_CALCULATIONS: "/2.0/Determine/ESP/ThrstFrceCalc",
    GET_SR_PROTECTORS: "/2.0/Determine/SchematicCorrelation/SRProtectors",
    GET_PUMP_DATA: "/2.0/Determine/ESP/PumpSelCalc",
    GET_PUMP_FREE_GAS_CHECK: "/2.0/Determine/ESP/PmpFreeGasCheck",
    GET_PUMP_CALC_LABLES: "/2.0/Determine/ESP/PmpOPLabelCalc",
    GET_PUMP_CORRECTION_FACTOR_OVERRIDE: "/2.0/Determine/ESP/PumpCalculationsWithCorrectionFactorOverride",
    GET_PUMP_ITERATION: "/2.0/Determine/ESP/PumpIteration",
    GET_AI_PUMP_DATA: "/2.0/Determine/ESP/AIRequest",
    GET_PUMP_MAX_CALC: "/2.0/Determine/ESP/PumpMaxCalc",
    GET_CONVERT_UNIT: "/2.0/Determine/ESP/ConverToOutUnit",
    GET_PUMP_GRAPH_ONE_DATA: "/2.0/Determine/ESP/GetGraphData",
    GET_PUMP_COMPOSITE_GRAPH_DATA: "/2.0/Determine/ESP/GetCompositeGraphData",
    GET_PUMP_GRAPH_TWO_DATA: "/2.0/Determine/ESP/GetGraphData2",
    GET_PUMP_GRAPH_THREE_DATA: "/2.0/Determine/ESP/GetGraphData3",
    GET_SR_BOH: "/2.0/Determine/SchematicCorrelation/SRBOH",
    GET_SR_PUMP: "/2.0/Determine/SchematicCorrelation/SRPumps?pump=",
    GET_SR_ABOVE_ESP: "/2.0/Determine/SchematicCorrelation/SRAccAboveESP",
    GET_SR_BELOW_ESP: "/2.0/Determine/SchematicCorrelation/SRAccBelowESP",
    GET_PROJECT_DETAILS: "/2.0/Determine/Project/GetProjectDetails?rowid=",
    GET_SURFACE_CNTRL: "/2.0/Determine/ESP/SurfEqContrlr",
    GET_SWITCH_BOARD: "/2.0/Determine/ESP/SwtchBrd",
    GET_KVA_CALC: "/2.0/Determine/ESP/KVACalculation",
    GET_DRIVE_AMP_CALC: "/2.0/Determine/ESP/DriveAmpCalc",
    GET_ELECTRIC_COST: "/2.0/Determine/ESP/ElectricCostCalc",
    GET_HARMONIC_FILTERS_AND_RECOMMENDATIONS: "/2.0/Determine/ESP/GetHarmonicFiltersAndRecommendations",
    GET_SR_VSD: "/2.0/Determine/SchematicCorrelation/SRVSDs",
    GET_SR_TRANSFORMER: "/2.0/Determine/SchematicCorrelation/SRTransformers",
    IMPORT_WELL_SURVEY_DATA: "/2.0/Determine/ESP/ImportSurveyData",
    GET_WELL_SURVEY_DATA: "/2.0/Determine/ESP/GetWellSurveyInformation?projectId=",
    CLEAR_WELL_SURVEY_DATA: "/2.0/Determine/ESP/ClearSurveyData?projectId=",
    GET_MY_DOCUMENTS_PROJECTS: "/2.0/Determine/Project/GetMyDocumentProjects",
    GET_OTHER_DOCUMENTS_PROJECTS: "/2.0/Determine/Project/GetOtherDocumentProjects",
    GET_CATALOG_DATA: "/2.0/Determine/Catalog/CatalogData",
    GET_CATALOG_EXPORT_EXCEL: "/2.0/Determine/Catalog/ExportExcel",
    VALIDATE_CATALOG_EXCEL: "/2.0/Determine/Catalog/ValidateExcel",
    CATALOG_BULK_IMPORT: "/2.0/Determine/Catalog/BulkImport",
    CATALOG_AUDIT_DATA: "/2.0/Determine/Catalog/CatalogAuditData",
    GET_CASE_COMMENTS: "/2.0/Determine/Project/GetCaseComments",
    GET_INSERT_AND_UPDATE_COMMENTS: "/2.0/Determine/Project/InsertAndUpdateComments",
    DELETE_COMMENT: "/2.0/Determine/Project/DeleteComment?id=",
    GET_CASE_CHANGE_LOG: "/2.0/Determine/Project/GetCaseChangeLogs",
} as const;